/**
 * Détecte si l'application tourne dans Electron
 */
export const isElectron = (): boolean => {
  if (typeof window === 'undefined') return false;
  
  // Vérifier via l'API Electron
  const electronAPI = (window as any).electronAPI;
  if (electronAPI?.isElectron && electronAPI.isElectron()) {
    return true;
  }
  
  // Vérifier via user agent
  if (navigator.userAgent.toLowerCase().includes('electron')) {
    return true;
  }
  
  return false;
};

